export const getLivraisonClientData = state => state.livraisonClientContent;
